<script>
import TwContainerFullWidth from '../../../components/generic/tw-container-full-width.vue'
import TwCard from '@/components/generic/tw-card.vue'
import TwButton from '@/components/generic/tw-button.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import DonateAmountField from '@/components/donations/public/donate-amount-field.vue'
import TwCheckbox from '@/components/generic/forms/tw-checkbox.vue'
import TwValidationErrors from '@/components/generic/tw-validation-errors.vue'
import TwInput from '@/components/generic/forms/tw-input.vue'
import TwTextarea from '@/components/generic/forms/tw-textarea.vue'
import TwTransitionListContainer from '@/components/generic/tw-transition-list-container.vue'
import TwProgressBar from '@/components/generic/tw-progress-bar.vue'
import FundraiserDonationAppFeeCard from '@/components/fundraisers/public/fundraiser-donation-app-fee-card.vue'
import fundraiserPageDonateMixin from '@/mixins/fundraiserPageDonateMixin.js'
import TwTimeLeft from '@/components/generic/tw-time-left.vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import DonateTakeCareOfFeesCard from '../../../components/donations/public/donate-take-care-of-fees-card.vue'

export default {
  name: 'FundraiserPageDonatePage',
  components: { DonateTakeCareOfFeesCard, FundraiserDonationAppFeeCard, TwTransitionListContainer, TwTextarea, TwInput, TwValidationErrors, TwCheckbox, DonateAmountField, TwTransitionContainer, TwButton,  XMarkIcon },
  mixins:[fundraiserPageDonateMixin],
  data() {
    return {
      DonationPublicMessage: false
    };
  }
}
</script>

<template>
  <tw-transition-container>
    <div v-if="fundraiserPage" class="h-100">
      <div v-if="fundraiserPage" class="w-full bg-cover bg-center bg-no-repeat fixed h-screen bg-overlay z-0" :style="`background-image: url('${fundraiserPage.cover_image_url}');`" />
      <div class="z-10 flex justify-center sm:p-6 relative z-1">
        <tw-transition-list-container>
          <div class="w-full sm:max-w-lg">
            <div v-if="fundraiserPage" class="rounded-none sm:rounded-2xl bg-white shadow-sm relative p-6 md:p-8 min-h-screen sm:min-h-max">
              <tw-button variant="link" class="absolute right-4 top-4" :to="{ name: 'FundraiserPagePublicPage', params: { fundraiserPageId: fundraiserPage.id, slug: fundraiserPage.slug} }">
                <XMarkIcon class="size-7" />
              </tw-button>
              <div class="flex gap-3 flex-col text-center mt-8 mb-4">
                <h1>
                  {{ fundraiserPage.title }}
                </h1>
                <h6> by <span>{{ fundraiserPage.cached.beneficiary_name }}</span> </h6>
                <!-- <div class="my-4">
                    <h5 v-if="fundraiserPage.cached.remaining > 0">
                      ${{ fundraiserPage.cached.remaining_formatted }} remaining to go
                    </h5>
                    <tw-progress-bar class="mt-3 mb-2" :progress="fundraiserPage.cached.percentage_raised" />
                    <tw-time-left class="text-sm text-gray-600" :deadline="fundraiserPage.deadline" detailed />
                  </div> -->
              </div>
              <div v-if="!DonationCompleted">
                <div>
                  <!-- <h5 class="text-center mt-5">
                      Amount to Give:
                    </h5> -->
                  <div v-if="!DonationGatewayActive && !DonationCompleted">
                    <donate-amount-field ref="donationField" v-model="DonationAmount" size="lg" :currency="donationCurrency" />
                    <donate-take-care-of-fees-card v-if="fundraiser && fundraiser.settings.allow_donors_to_absorb_credit_card_fees" v-model="DonationTakeCareOfFees" class="mt-2" :currency="donationCurrency" :donation-stripe-fee-offset-amount="donationStripeFeeOffsetAmount" />
                    <div v-if="fundraiser && fundraiser.settings && fundraiser.settings.enable_recurring_donations" class="mt-2">
                      <tw-checkbox v-model="DonationRecurring" label="Make this a monthly donation" />
                      <tw-transition-container>
                        <div v-if="DonationRecurring && recurrencesAvailable.length > 1" class="grid grid-cols-3 gap-2">
                          <tw-button v-for="recurrence in recurrencesAvailable" :key="'recurrences-key-' + recurrence" :fa-icon="DonationRecurrences === recurrence? 'check':null" block :variant="DonationRecurrences === recurrence? 'success':'secondary'" size="sm" @click="DonationRecurrences = recurrence">
                            {{ recurrenceLabel(recurrence) }}
                          </tw-button>
                        </div>
                      </tw-transition-container>
                    </div>
                    <div v-if="fundraiserPage.cached && fundraiserPage.cached.donation_highest_amount > 0" class="mt-6 text-center text-sm bg-gray-50 p-4 rounded-lg">
                      A donation of <span class="text-amber-500 underline cursor-pointer font-medium" @click="DonationAmount = fundraiserPage.cached.donation_highest_amount + 1">{{ $filters.formatCurrency(fundraiserPage.cached.donation_highest_amount + 1, donationCurrency) }} or more</span> would make you the top giver so far.
                    </div>
                    <div class="flex flex-col gap-2">
                      <tw-input v-model="DonationName" required class="mt-4 mb-1" label="Name" placeholder="Enter your name" />
                      <tw-checkbox v-model="DonationAnonymousName">
                        Keep my name hidden from public view
                      </tw-checkbox>
                      <tw-checkbox v-model="DonationAnonymousAmount">
                        Keep my amount hidden from public view
                      </tw-checkbox>
                      <tw-checkbox v-model="DonationShowCommentForm">
                        Leave a public message
                      </tw-checkbox>
                      <div v-if="DonationShowCommentForm" class="mt-1">
                        <tw-textarea v-model="DonationComment" class="w-full" rows="3" placeholder="Enter your message" />
                      </div>
                    </div>
                    <fundraiser-donation-app-fee-card v-if="fundraiser && !fundraiser.settings.app_fee_included" v-model="DonationAppFeeAmount" :currency="donationCurrency" :donation-amount="DonationAmount" class="mt-5 mb-3" />
                    <div class="mt-8 flex justify-between items-center">
                      <h5>
                        Donation Total:
                      </h5>
                      <div class="text-right">
                        {{ $filters.formatCurrency(donationTotalAmount, donationCurrency) }}
                      </div>
                    </div>
                    <div class="mt-4">
                      <tw-button block variant="amber" size="lg" :disabled="donateButtonDisabled" @click="startDonation">
                        {{ continueButtonLabel }}
                      </tw-button>
                    </div>
                  </div>
                </div>
              </div>
              <tw-validation-errors :validation-result-error="ValidationErrorMessage" />
              <tw-transition-list-container>
                <div v-if="DonationGatewayActive" id="checkout" />
                <!-- TODO: Should this be a back button? It takes the user back to the previous step but then the continue button does not work after that. This seams like a glitch?
                  <tw-button v-if="DonationGatewayActive" class="mt-2" size="lg" block variant="secondary" @click="cancelDonation">
                    Cancel
                  </tw-button> -->
              </tw-transition-list-container>
              <div class="mt-4 text-xs text-center">
                <i class="pi pi-lock mr-1" /> All proceeds of your donation will go directly to <strong v-if="fundraiser">{{ fundraiser.cached.beneficiary_name }}</strong> on behalf of <strong> {{ fundraiserPage.cached.owner_name }} </strong>.
              </div>
            </div>
          </div>
        </tw-transition-list-container>
      </div>
    </div>
  </tw-transition-container>
</template>

<style scoped>

</style>
